import React from "react";
import { Row, Col, Typography, InputNumber, Divider, Button } from "antd";
import { useFormContext, Controller } from "react-hook-form";
import translator from "@/translator";

const { Text } = Typography;
const t = translator("front_office.views.yclients_notification_settings.");

const VisitsCountFilter = () => {
  const { control, setValue } = useFormContext();

  const resetVisitCount = () => {
    setValue("filters.visits_count_from", 0);
    setValue("filters.visits_count_to", null);
  };

  return (
    <div className="yclients-notification-settings-filter-visits-count__container">
      <div className="yclients-notification-settings-filter-visits-count__inputs-container">
        <span className="yclients-notification-settings-filter-visits-count__label">{t("fields.filters.visits_count_from")}</span>
        <Controller
          control={control}
          name="filters.visits_count_from"
          defaultValue={0}
          render={({ field: { onChange, value } }) => (
            <InputNumber
              min={0}
              value={value}
              onChange={onChange}
              className="yclients-notification-settings-filter-visits-count__input-number"
            />
          )}
        />
        <span className="yclients-notification-settings-filter-visits-count__separator">{t("fields.filters.visits_count_to")}</span>
        <Controller
          control={control}
          name="filters.visits_count_to"
          render={({ field: { onChange, value } }) => (
            <InputNumber
              min={0}
              value={value}
              onChange={onChange}
              className="yclients-notification-settings-filter-visits-count__input-number"
            />
          )}
        />
      </div>
      <div className="yclients-notification-settings-filter-visits-count__reset-button">
        <Button className="ant-custom-btn" onClick={resetVisitCount} icon={"×"}>
          <span className="yclients-notification-settings-filter-visits-count__reset-button-text">{t("common.reset")}</span>
        </Button>
      </div>
    </div>
  );
};

const VisitsBetweenFilter = () => {
  const { control, setValue } = useFormContext();

  const resetVisitsBetween = () => {
    setValue("filters.visits_count_between", 0);
  };

  return (
    <div className="yclients-notification-settings-filter-visits-count__container">
      <Controller
        control={control}
        name="filters.visits_count_between"
        defaultValue={0}
        render={({ field: { onChange, value } }) => (
          <InputNumber
            min={0}
            value={value}
            onChange={onChange}
            className="yclients-notification-settings-filter-visits-count__input-number"
          />
        )}
      />
      <div className="yclients-notification-settings-filter-visits-count__reset-button">
        <Button className="ant-custom-btn" onClick={resetVisitsBetween} icon={"×"}>
          <span className="yclients-notification-settings-filter-visits-count__reset-button-text">{t("common.reset")}</span>
        </Button>
      </div>
    </div>
  );
};

const FilterVisitsCount = () => {
  return (
    <Row>
      <Col sm={24} xl={11}>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Text strong>{t("fields.filters.visits_count_title")}</Text>
          </Col>
          <Col span={24}>
            <Text className="yclients-notification-settings-create__helper-text">
              {t("fields.filters.visits_count_description")}
            </Text>
          </Col>
        </Row>
      </Col>
      <Col sm={0} xl={2} />
      <Col sm={24} xl={11}>
        <VisitsCountFilter />
      </Col>

      <Divider />

      <Col sm={24} xl={11}>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Text strong>{t("fields.filters.visits_between_title")}</Text>
          </Col>
          <Col span={24}>
            <Text className="yclients-notification-settings-create__helper-text">
              {t("fields.filters.visits_between_description")}
            </Text>
          </Col>
        </Row>
      </Col>
      <Col sm={0} xl={2} />
      <Col sm={24} xl={11}>
        <VisitsBetweenFilter />
      </Col>
    </Row>
  );
};

export default FilterVisitsCount;
